import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../styles/LoginPage.css";
import logo from "../../../assets/icons/NewLogo.png";
import { AuthServices } from "../services/AuthServices";
import GoogleAuth from "../../../shared/utils/GoogleAuth";

function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [localStorageEmail, setLocalStorageEmail] = useState(null);
  const [show, setShow] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const [showResend, setShowResend] = useState(false);

  const handleEmailLogin = async () => {
    const trimmedEmail = email.trim();
    const isEmpty = trimmedEmail === "";
    const isInvalidFormat = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail);

    if (isEmpty || isInvalidFormat) {
      setEmailError(true);
      return;
    }

    try {
      await AuthServices.sendOtp({ email: trimmedEmail });
      localStorage.setItem("email", trimmedEmail);
      setLocalStorageEmail(trimmedEmail);
      setEmailError(false);
      setIsOtpSent(true);
      setShowResend(false);
      console.log(`OTP sent to: ${trimmedEmail}`);
      setTimeout(() => setShowResend(true), 15000);
    } catch (error) {
      console.error("Error sending OTP:", error);
      alert("Failed to send OTP. Please try again.");
    }
  };

  const handleVerifyOtp = async () => {
    if (otp.length !== 6) return alert("Enter a 6-digit code");

    try {
      const response = await AuthServices.verifyOtp({
        email: localStorageEmail,
        otp,
        role: "LOGIN",
      });
      if (response.status !== 200) {
        return alert("Invalid OTP. Please try again.");
      }
      navigate("/home");
    } catch (error) {
      return console.error("Error verifying OTP:", error);
    }
  };

  const sendOTP = async (emailToUse) => {
    try {
      const response = await AuthServices.sendOtp({ email: emailToUse });
      if (response.status === 200) {
        console.log("OTP sent successfully");
      } else {
        console.error("Failed to send OTP:", response);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      alert("Failed to send OTP. Please try again.");
    }
  };

  useEffect(() => {
    const timeout = setTimeout(() => setShow(true), 200);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="login-page">
      <div className="top-logo">
        <img src={logo} alt="PrashaSync Logo" className="login-logo" />
      </div>
      <div className={`login-card ${show ? "show" : ""}`}>
        {!isOtpSent ? (
          <>
            <h2 className="login-title">Login</h2>
            <input
              type="email"
              className={`email-input ${emailError ? "input-error" : ""}`}
              placeholder="Email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                if (emailError) setEmailError(false);
              }}
            />
            {emailError && (
              <p
                style={{ color: "#e03131", fontSize: "13px", marginTop: "6px" }}
              >
                Please enter a valid email address.
              </p>
            )}
            <button className="continue-button" onClick={handleEmailLogin}>
              Continue
            </button>

            <div className="separator">
              <span className="or-text">or</span>
            </div>

            <GoogleAuth />

            <p className="terms-text">
              By continuing you agree to <a href="https://prashauploadimages.blob.core.windows.net/docs/PraSha%20Sync%20terms%20of%20use.pdf " target="_blank" rel="noopener noreferrer">Terms of Service</a> and{" "}
              <a href="https://prashauploadimages.blob.core.windows.net/docs/PraShaSync%20privacy%20policy.pdf " target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
            </p>
          </>
        ) : (
          <>
            <h3 className="otp-title">Check your inbox</h3>
            <p className="otp-subtext">
              Enter the 6-digit code we sent to <strong>{email}</strong> to
              finish your login.
            </p>
            <input
              type="text"
              className={`email-input ${otpError ? "input-error" : ""}`}
              placeholder="6-digit code"
              value={otp}
              onChange={(e) => {
                setOtp(e.target.value);
                if (otpError) setOtpError(false);
              }}
              maxLength={6}
            />
            {otpError && (
              <p
                style={{ color: "#e03131", fontSize: "13px", marginTop: "6px" }}
              >
                Please enter a valid 6-digit code.
              </p>
            )}

            <button className="continue-button" onClick={handleVerifyOtp}>
              Login
            </button>
            <p
              className={`resend-code ${!showResend ? "disabled" : ""}`}
              onClick={showResend ? handleEmailLogin : undefined}
            >
              Resend code
            </p>

          </>
        )}
      </div>
    </div>
  );
}

export default LoginPage;
